module.exports = __webpack_public_path__ + "static/media/img-5.3aaecb2e.jpg";